import { apiGetRequest, apiPostRequest } from 'utilities/http/api/apiHttp';
import { UserCapabilitiesTypes, Credentials, User } from 'types';

export const apiUser = {
  authLogin: (body: Credentials) => apiPostRequest<{ token: string }>(`auth/login`, body),

  getUser: () => apiGetRequest<{ user: User }>(`user`),

  getCapabilities: () =>
    apiGetRequest<{ capabilities: UserCapabilitiesTypes[] }>(`access/capabilities`),
};
